import {
  Box,
  Typography,
  TextField,
  FormControl,
  Stack,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Tooltip,
} from '@mui/material';
import i18n from '../../../../libs/language';
import SearchIcon from '@old/assets/svg/search.svg';
import { stylesInput } from '@old/styles/generic-styles';
import { customBgWhite } from '@old/styles/generic-styles';
import { BaseTable } from '@old/ui/table';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useService } from '@old/hooks/use-service';
import { getEstablishmentsCorvusService } from '@old/services/integration/corvus/get-establishment-corvus';
import { getProductsCorvusService } from '@old/services/integration/corvus/get-products-corvus';
import { GridColDef, GridRowId } from '@mui/x-data-grid';
import { formatDateTime } from '@old/utils/helper';
import checkIcon from '@old/assets/svg/check-with-border.svg';
import checkIconYellow from '@old/assets/svg/check-icon-yellow.svg';
import editIcon from '@old/assets/svg/edit-svg-blue.svg';
import editIconYellow from '@old/assets/svg/edit-svg-yellow.svg';
import exclamationIcon from '@old/assets/svg/exclamation-icon.svg';
import exclamationIconYellow from '@old/assets/svg/exclamation-icon-yellow.svg';
import { formatNumberWithSeparators } from '@old/utils/helper';
import DeleteIcon from '@old/assets/svg/core/trash-red.svg';
import { getCorvusHeavyLogs } from '@old/services/integration/corvus/get-heavy-logs';
import { getSilobagInfoCorvusService } from '@old/services/integration/corvus/get-silobag-info-corvus';
import { deleteHeavyLogsCorvusService } from '@old/services/integration/corvus/delete-heavy-logs';
import clockIcon from '@old/assets/svg/clock.svg';
import { Selector } from '@old/ui/selector/selector';
// import { GridRowSelectionModel } from '@mui/x-data-grid';

type BodyDeleteHeavyLogs = Parameters<typeof deleteHeavyLogsCorvusService>[0];

type SilobagInfoCorvusSummary = Awaited<
  ReturnType<typeof getSilobagInfoCorvusService>
>['summary']['heavyLogs'];

type HeavyLogsSummary = Awaited<ReturnType<typeof getCorvusHeavyLogs>>['summary'];
type ParametersHeavyLogs = Parameters<typeof getCorvusHeavyLogs>[0]['query'];

type stepType = {
  SELECT_HEAVY_LOGS: string;
  CONFIRM_HEAVY_LOGS: string;
  CORVUS_DETAIL: string;
};

type WeightType = {
  WET: string;
  DRY: string;
};

type HeavyLockState = {
  [key: number]: {
    description: string;
    icon: string;
  };
};

type CorvusTableProps = {
  step: string;
  params: ParametersHeavyLogs;
  setParams: (value: ParametersHeavyLogs) => void;
  getHeavyLogs: () => void;
  data?: HeavyLogsSummary | SilobagInfoCorvusSummary;
  dataSelected?: HeavyLogsSummary;
  isLoading: boolean;
  setHeavyLogsSelected: (value: HeavyLogsSummary) => void;
  setDateRange: (value: [Dayjs | null, Dayjs | null]) => void;
  dateRange: [Dayjs | null, Dayjs | null];
  deleteHeavyLog: ({ body, query }: BodyDeleteHeavyLogs) => void;
  isLoadingInfo: boolean;
  siloId?: string;
  stepType: stepType;
  weightState: string;
  handleWeightState: (value: string) => void;
  WeightType: WeightType;
  activeState: boolean;
};

export function CorvusTable(props: CorvusTableProps) {
  const {
    step,
    data,
    isLoading,
    setHeavyLogsSelected,
    dataSelected,
    dateRange,
    setDateRange,
    setParams,
    params,
    deleteHeavyLog,
    siloId,
    isLoadingInfo,
    stepType,
    weightState,
    handleWeightState,
    WeightType,
    activeState,
  } = props;
  const today = dayjs();
  const [startDate, endDate] = dateRange;
  const { summary: establishments, isLoading: isLoadingEstablishment } = useService(
    getEstablishmentsCorvusService,
    {
      fetchOnMount: true,
    }
  );

  const { summary: products, isLoading: isLoadingProducts } = useService(getProductsCorvusService, {
    fetchOnMount: true,
  });
  const dataFormated = data ? data.map((item) => ({ id: item.heavy_log_id, ...item })) : [];

  const rows =
    step === stepType.SELECT_HEAVY_LOGS || step === stepType.CORVUS_DETAIL ? dataFormated : dataSelected;

  function removeItemById(array: HeavyLogsSummary, id: number) {
    const arrayFiltered = array.filter((item) => item.heavy_log_id !== id);
    setHeavyLogsSelected(arrayFiltered);
  }

  const handleDateChange = (newDate: Dayjs | null, index: number) => {
    if (newDate) {
      const updatedDateRange = [...dateRange];
      updatedDateRange[index] = newDate;
      setDateRange(updatedDateRange as [Dayjs, Dayjs]);
    }
  };

  const handleReset = () => {
    setDateRange([null, null]);
    setParams && setParams({ description: '', establishmentId: '', productId: '' });
  };
  const handleRowSelected = (selectedRow: HeavyLogsSummary | GridRowId[]) => {
    setHeavyLogsSelected && setHeavyLogsSelected(selectedRow as HeavyLogsSummary);
  };

  const deleteEstablishmentFilter = () => {
    setParams && setParams({ ...params, establishmentId: '' });
  };

  const deleteProductFilter = () => {
    setParams && setParams({ ...params, productId: '' });
  };
  const heavyLockState: HeavyLockState = {
    3: {
      description: 'Descarga Automática',
      icon: checkIcon,
    },
    11: {
      description: 'Descarga Modificada',
      icon: editIconYellow,
    },
    24: {
      description: 'SobrePeso',
      icon: exclamationIconYellow,
    },
    25: {
      description: 'Tiempo minimo',
      icon: clockIcon,
    },
    28: {
      description: 'Descarga Manual en balanza',
      icon: checkIconYellow,
    },
    29: {
      description: 'Descarga Modificada en balanza',
      icon: editIcon,
    },
    31: {
      description: 'Descarga defectuosa en balanza',
      icon: exclamationIcon,
    },
  };
  const columns: GridColDef[] = [
    {
      field: 'corvus_state_heavy_check_id',
      display: 'flex',
      headerName: 'Tipo',
      flex: 1,
      renderCell: (params) => {
        const valueId: number = params.value;
        const value = heavyLockState[valueId];
        return (
          <Tooltip title={value?.description ?? ''}>
            <img src={value?.icon ?? checkIcon} style={{ width: 16, height: 16 }} />
          </Tooltip>
        );
      },
    },
    {
      field: 'heavy_log_date',
      display: 'flex',
      headerName: 'Fecha Pesada',
      flex: 1,
      renderCell: (params) => {
        const date = formatDateTime(params.value, 2);
        return <div>{date}</div>;
      },
    },
    { field: 'description', headerName: i18n.t('app.name'), flex: 1 },
    {
      field: 'corvus_establishment_id',
      display: 'flex',
      headerName: i18n.t('app.countryside'),
      flex: 1,
      renderCell: (params) => {
        const establisment = params.row.corvus_establishment.name;
        return <div>{establisment}</div>;
      },
    },
    {
      field: 'corvus_product_id',
      display: 'flex',
      headerName: i18n.t('app.silobag_data.product'),
      flex: 1,
      renderCell: (params) => {
        const product = params.row.corvus_product.name;
        return <div>{product}</div>;
      },
    },
    {
      field: 'type_weight',
      display: 'flex',
      headerName: 'Tipo de Peso',
      flex: 1,
      renderCell: () => {
        const typeToRender =
          weightState == WeightType.WET
            ? i18n.t('app.integration_corvus.wet')
            : i18n.t('app.integration_corvus.dry');
        return <div>{typeToRender}</div>;
      },
    },
    {
      field: 'corvus_batch',
      display: 'flex',
      headerName: i18n.t('app.silobag_data.lot_origin'),
      flex: 1,
      renderCell: (params) => {
        return <div>{params.value.name}</div>;
      },
    },
    {
      field: 'corvus_machine_id',
      display: 'flex',
      headerName: 'Tolva',
      flex: 1,
      renderCell: (params) => {
        const machine = params.row.corvus_machine.name;
        return <div>{machine}</div>;
      },
    },
    {
      field: 'wet_weight',
      display: 'flex',
      headerName: i18n.t('app.integration_corvus.weight_corvus'),
      flex: 1.2,
      renderCell: (params) => {
        const weightToRender = weightState == WeightType.WET ? +params.value : +params.row.dry_weight;
        return (
          <Stack direction={'row'} spacing={2} justifyContent={'center'} alignContent={'center'}>
            <p>{formatNumberWithSeparators(weightToRender)} kg</p>
          </Stack>
        );
      },
    },
    {
      field: 'id',
      display: 'flex',
      headerName: '',
      flex: 0.3,
      renderCell: (params) => {
        const paramsId = params.row.heavy_log_id;
        const bodyRequest = {
          heavyLogs: [{ heavyLogId: paramsId }],
        };
        return (
          <Stack direction={'row'} spacing={2} justifyContent={'center'} alignContent={'center'}>
            {activeState && (
              <Stack direction={'column'}>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (step === stepType.CONFIRM_HEAVY_LOGS) {
                      removeItemById(rows!, paramsId);
                    } else {
                      deleteHeavyLog({
                        body: bodyRequest,
                        query: siloId ?? 'id-not-found',
                      });
                    }
                  }}
                >
                  <img src={DeleteIcon} />
                </span>
              </Stack>
            )}
          </Stack>
        );
      },
    },
  ];

  return (
    <Box sx={{ marginTop: '20px' }}>
      <Typography variant="h6" fontWeight={500}>
        {step === stepType.SELECT_HEAVY_LOGS ? 'Elegir silobolsa en corvus' : ''}
      </Typography>
      {step === stepType.SELECT_HEAVY_LOGS ? (
        <Stack direction={'row'} spacing={1} sx={{ marginTop: '20px' }}>
          <FormControl
            style={{
              width: '250px',
              fontSize: 14,
              marginRight: '10px',
              height: '100%',
            }}
          >
            <TextField
              size="medium"
              variant="outlined"
              placeholder={'Buscar por ' + i18n.t('app.name')}
              style={stylesInput}
              onChange={(e) => setParams({ ...params, description: e.target.value })}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchIcon} alt="search-icon" />
                    </InputAdornment>
                  ),
                  inputProps: { style: { fontSize: 13, height: 22 } },
                },
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            size="medium"
            style={{ width: '250px', height: '100%', marginRight: '10px' }}
          >
            <Selector
              label={i18n.t('app.countrysides')}
              id="corvus_establishment_id"
              value={params?.establishmentId ?? ''}
              onChange={(e) => setParams({ ...params, establishmentId: e.target.value as number })}
              options={establishments}
              selectedList={params?.establishmentId ?? ''}
              renderValue={() =>
                establishments
                  ?.filter((countryside) => params?.establishmentId == countryside.corvus_establishment_id)
                  .map((matchedCountryside) => matchedCountryside.name)
              }
              deleteFilter={deleteEstablishmentFilter}
              disabled={isLoadingEstablishment}
              propToShow="corvus_establishment_id"
            />
          </FormControl>

          <FormControl
            variant="outlined"
            size="medium"
            style={{ width: '250px', height: '100%', marginRight: '10px' }}
          >
            <Selector
              label={i18n.t('app.silobag_data.product')}
              id="product_id"
              value={params?.productId ?? ''}
              onChange={(e) => setParams({ ...params, productId: e.target.value as number })}
              options={products}
              selectedList={params?.productId ?? ''}
              renderValue={() =>
                products
                  ?.filter((product) => params?.productId == product.corvus_product_id)
                  .map((matchedProduct) => matchedProduct.name)
              }
              deleteFilter={deleteProductFilter}
              disabled={isLoadingProducts}
              propToShow="corvus_product_id"
            />
          </FormControl>

          <FormControl
            variant="outlined"
            size="medium"
            style={{ width: '250px', height: '100%', marginRight: '10px' }}
            sx={stylesInput}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker
                label={i18n.t('app.report_stock.init_date')}
                value={startDate}
                onChange={(date) => handleDateChange(date ?? today, 0)}
                sx={stylesInput}
                slotProps={{
                  textField: {
                    size: 'medium',
                    inputProps: {
                      onKeyPress: (event: React.KeyboardEvent) => {
                        event.preventDefault();
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </FormControl>
          <FormControl
            variant="outlined"
            size="medium"
            style={{ width: '250px', height: '100%', marginRight: '10px' }}
            sx={stylesInput}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker
                label={i18n.t('app.report_stock.close_date')}
                value={endDate}
                onChange={(date) => handleDateChange(date ?? today, 1)}
                sx={stylesInput}
                slotProps={{
                  textField: {
                    size: 'medium',
                    inputProps: {
                      onKeyPress: (event: React.KeyboardEvent) => {
                        event.preventDefault();
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </FormControl>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="wet_weight"
              name="radio-buttons-group"
              sx={{ marginTop: -1.5 }}
            >
              <FormControlLabel
                value="wet_weight"
                control={<Radio size="small" />}
                label={
                  <Typography variant="body2" style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
                    {i18n.t('app.integration_corvus.wet_weight')}
                  </Typography>
                }
                onClick={() => handleWeightState(WeightType.WET)}
              />
              <FormControlLabel
                value="dry_height"
                control={<Radio size="small" />}
                onClick={() => handleWeightState(WeightType.DRY)}
                label={
                  <Typography variant="body2" style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
                    {i18n.t('app.integration_corvus.dry_weight')}
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
          <Button
            sx={{
              fontSize: 12,
              fontWeight: 500,
              padding: 1,
              textTransform: 'uppercase',
              visibility:
                startDate || endDate || params?.description || params?.establishmentId || params?.productId
                  ? ''
                  : 'hidden',
              color: '#FF0000',
            }}
            onClick={handleReset}
            startIcon={<img src={DeleteIcon} alt="delete-icon" />}
          >
            {i18n.t('app.clear_filters')}
          </Button>
        </Stack>
      ) : null}
      <Box sx={customBgWhite}>
        <BaseTable
          columns={columns}
          rows={rows ?? []}
          initialPageSize={50}
          enableSelection
          loading={isLoading || isLoadingInfo}
          checkboxSelection={step === stepType.SELECT_HEAVY_LOGS && activeState}
          selectFullRow
          onRowSelected={handleRowSelected}
        />
      </Box>
    </Box>
  );
}
